import { makeImmutable } from "../../core/makeImmutable";
export class LoyaltyOrderSelector {
    constructor() {
        this.type = "Loyalty";
        makeImmutable(this);
    }
    test(purchaseOrderPayload) {
        throw new Error("FIXME Implement");
    }
}
